/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { object } from 'prop-types';

class ImageCard extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { imageCard } = this.props;
        const petFriendlyIcon = ['Not safe for furry friends', 'Not safe for furry friends or kids', 'Best to keep away from furry friends', 'Best to keep away from pets and children'].indexOf(imageCard.description) >= 0;
        if (imageCard.id === 'care_tips_friendliness' && petFriendlyIcon) imageCard.img_url = 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt2fedbfcfa88c41f5/63ecfeb5e4d5251cb4688299/pet-not-friendly.svg';

        const fullDescription = () => (
            <>
                {imageCard?.label ? <span className="mb-0 pl-3 h6" role="heading" aria-level="3"> {imageCard.label} </span> : null }
                {(imageCard?.description) ? <p> {imageCard.description} </p> : null}
            </>
        );
        return (
            <div className="image-card">
                <div className="image-card-inner">
                    <img src={imageCard.img_url} alt={imageCard.label} height={imageCard.height} width={imageCard.width} />
                </div>
                { fullDescription() }
            </div>
        );
    }
}

ImageCard.propTypes = {
    imageCard: object.isRequired,
};

export default React.memo(ImageCard);
